import { render, staticRenderFns } from "./CompareTickersModalWrapper.vue?vue&type=template&id=4bbb6dca"
import script from "./CompareTickersModalWrapper.vue?vue&type=script&lang=js"
export * from "./CompareTickersModalWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports